import { cookieService } from "@/services";
import { useSelector } from 'react-redux';
import useExtraData from './useExtraData';
import { TLifestyleHeader } from '@types';
import { useEffect, useState } from 'react';

const extradataOverrides = {
  // [ProductTypeId.ULTRA_LIGHT_52_QT_WHEELED]: {
  //   extraData: {
  //     video: 'https://static.velkybrands.com/v/wheeled-52-nascar_d.mp4',
  //     videoMob: 'https://static.velkybrands.com/v/wheeled-52-nascar_m.mp4',
  //   },
  //   properties: {
  //     cookie: 'c-nascar_video',
  //     checkFn: () => {
  //       return (
  //         window.location.search.includes('utm_source=youtube') &&
  //         window.location.search.includes('utm_medium=rtic-channel') &&
  //         window.location.search.includes('utm_campaign=nascar-video')
  //       );
  //     },
  //   },
  // },
};

export const useLifestyleHeaderOverride = () => {
  const typeId = useSelector((state: any) => state.pdpItem.details?.attributes?.typeId);
  const extraData = useExtraData();
  const [lifestyleHeader, setLifestyleHeader] = useState<TLifestyleHeader | null>(
    extraData?.lifestyleHeader ?? null
  );

  const getLifestyleHeaderValue = () => {
    const currentValue = extraData?.lifestyleHeader ?? null;
    const overriddenValue = extradataOverrides[typeId];

    if (Boolean(overriddenValue)) {
      const overriddenCookie = cookieService.get(overriddenValue.properties.cookie);
      const shouldOverride = overriddenValue.properties.checkFn();
      if (overriddenValue && (overriddenCookie || (!overriddenCookie && shouldOverride))) {
        cookieService.set(overriddenValue.properties.cookie, 'true', {
          expires: 30,
        });

        return {
          ...(Boolean(currentValue) ? currentValue : {}),
          ...overriddenValue.extraData,
        };
      }
    } else {
      return Object.keys(currentValue).length > 0 ? currentValue : null;
    }

    return Object.keys(currentValue).length > 0 ? currentValue : null;
  };

  useEffect(() => {
    if (extraData?.lifestyleHeader) {
      setLifestyleHeader(getLifestyleHeaderValue());
    } else {
      setLifestyleHeader(null);
    }
  }, [typeId, extraData]);

  return lifestyleHeader;
};
